import to from 'await-to-js'
import axios from '@/utils/axios-api'

const BASE_URL_AI = process.env.VUE_APP_API_AI_TOOLS

export default class AI {
  static async updateCompanyActivity (companyName: string, companyDescription: string) {
    const params = new URLSearchParams()
    params.append('company_name', companyName)
    params.append('company_description', companyDescription)

    return await to(axios.get(`${BASE_URL_AI}/ai/generate-objetos-sociales/?${params.toString()}`)) as any
  }
}
